export const EmptyState: React.FC = () => (
  <div className="mt-12 bg-white dark:bg-gray-800 rounded-lg p-12 text-center border-2 border-dashed border-slate-400 dark:border-slate-700 bg-linear-to-br from-slate-100 via-slate-50 to-slate-100 dark:from-slate-800/20 dark:via-slate-800/30 dark:to-slate-800/20">
    <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-slate-200 dark:bg-slate-800/50 mb-4 border-2 border-slate-400 dark:border-slate-700">
      <svg
        className="w-10 h-10 text-slate-600 dark:text-slate-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        />
      </svg>
    </div>
    <h3 className="text-xl font-semibold text-slate-900 dark:text-slate-50 mb-2">
      No Recommendations Selected
    </h3>
    <p className="text-slate-700 dark:text-slate-400">
      Choose one or more fixes above to see how they'll improve your codebase
    </p>
  </div>
);
